<div class="dialog-title mat-tab-label-active text-muted font-family px-3">
  <div>{{"my-invoices"|translate}}</div>

  <div>
    <button cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle mat-icon-button
      class="drag-handler text-center" style="cursor: grab;">
      <mat-icon style="font-size: 18px;">open_with</mat-icon>
    </button>
    <button mat-icon-button class="text-center" mat-dialog-close>
      <mat-icon style="font-size: 18px;">close</mat-icon>
    </button>
  </div>
</div>

<body id="dark" class="noprint">
<div class="row align-items-end justify-content-between mx-2 py-2">
    <div class="col-3">
      <label class="w-100 text-color-theme">{{"date-from"|translate}}</label>
      <input (focus)="pickerFrom.open()" class="form-control" #date id="date" matInput name="depositDate"
        [(ngModel)]="dateFrom" [matDatepicker]="pickerFrom" [max]="dateTo || maxDate" readonly>
      <mat-datepicker #pickerFrom></mat-datepicker>
    </div>

    <div class="col-3">
      <label class="w-100 text-color-theme">{{"date-to"|translate}}</label>
      <input (focus)="pickerTo.open()" class="form-control" #date id="date" matInput name="depositDate"
        [(ngModel)]="dateTo" [matDatepicker]="pickerTo" [max]="dateTo || maxDate" readonly>
      <mat-datepicker #pickerTo></mat-datepicker>
    </div>


      <!-- <user-selection [isBindValue]="true" [inputUser]="(inputUser!=null)?inputUser:null" (userChanged)="selectedClient = $event.relationCode"></user-selection> -->
<div class="row align-items-end justify-content-between mx-2 py-2">
    <div class="col-xl-3 col-lg-3 col-md-3 col-12 mt-sm-3 mt-3">
      <div class="mb-3 d-flex justify-content-between">
        <div>
          <h6 class="profile-heading text-color-theme">
            {{ "Arabic" | translate }}
          </h6>
        </div>
        <div>
          <mat-slide-toggle color="primary" [(ngModel)]="isReportArabic">
          </mat-slide-toggle>
        </div>
      </div>
    <!-- <div class="col-xl-2 col-lg-2 col-md-6 col-12 align-self-end my-xl-0 my-lg-0 my-md-0 my-3 d-flex align-items-start"> -->
       </div>
    <div class="col-xl-6 col-lg-6 col-md-6 col-12 d-flex justify-content-end">
      <button class="btn btn-primary" (click)="onDateChange()">
        {{"search"|translate}}
      </button>
    </div>
  </div>


  <div *ngIf="!invoices || invoices.length==0" class="text-center p-5 mx-auto" >
    <img class="empty-state" src="/assets/img/noData.png" />
    <div class="col-sm-12">
      <h6 class="text-warning mt-2" *ngIf="selectedClient"> {{'no-invoice'|translate}} </h6>
      <h6 class="text-warning mt-2" *ngIf="!selectedClient"> {{'choose-client'|translate}} </h6>
    </div>
  </div>
  <div style="max-height: 70vh;overflow: scroll;width: 100%;">
    <div *ngFor="let item of invoices" style="height: fit-content;width: 100%;" dir="rtl" class="container">

      <div class="mx-2" style="page-break-after:always">
        <br>
        <div class="market-pairs">
          <div class="text-color-theme p-3">
            <div class="row mx-1">
              <div class="col-4" style="text-align: center;">
                <h6>نوع العملية: {{isArabic? item.TransactionTypeA:item.TransactionTypeE}}</h6>
              </div>

              <div class="col-4" style="text-align: center;">
                <h6>السوق: {{isArabic? item.MarketNameA:item.MarketNameE}}</h6>
                <h6>الفرع: {{isArabic? item.BranchNameA:item.BranchNameE}}</h6>
              </div>
            </div>
          </div>
          <div class="tab-content">
            <div class="tab-pane fade show active table-custom" id="recent-trades" role="tabpanel">
              <table class="table table-sm">
                <thead style="z-index: 100;">
                  <th class="fit">رقم الفاتورة</th>
                  <th class="fit">تاريخ الفاتورة</th>
                  <th class="fit">الورقة</th>
                  <th class="fit">الكمية</th>
                  <th class="fit">م. السعر</th>
                  <th class="fit">القيمة</th>
                  <th></th>
                </thead>
                <tbody>
                  <tr >
                    <td class="fit">{{item.PostedSerial}}</td>
                    <td class="fit">{{item.InvoiceDate|date}}</td>
                    <td class="fit">{{isArabic? item.SymbolNameA:item.SymbolNameE}}</td>
                    <td class="fit">{{item.Qty | number}}</td>
                    <td class="fit">{{item.AvgPrice| number: "1.2-2":"en-US"}}</td>
                    <td class="fit">{{item.NetAmount | number: "1.2-2":"en-US"}}</td>
                    <td class="fit">
                      <!-- <button *ngIf="invoice != selectedInvoice" (click)="selectInvoice(invoice)" class="btn btn-sm btn-primary">
                      {{"preview"|translate}}
                    </button> -->
                      <button class="btn btn-sm btn-primary"
                        (click)="tryGenerate(item)">{{"preview"|translate}}</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>
      <br>

    </div>
  </div>

</div>
</body>

<!-- <app-statement-details id="print-section" ></app-statement-details> -->